export const TrowelBrush = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="19.0029"
          y="1.99585"
          width="3.00125"
          height="19.0079"
          rx="1.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.20758 10.2692H6.19757L6.05751 4.99705C6.04679 4.30367 6.4068 3.65724 7.00193 3.30126C7.59705 2.94528 8.33689 2.93384 8.94274 3.27125C9.54858 3.60865 9.92841 4.24365 9.93913 4.93703V4.99705L9.79907 10.2692H9.78907"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.99832 9.99915V9.99915C4.68323 9.99915 1.99582 12.6866 1.99582 16.0016V20.0033C1.99582 20.5558 2.44372 21.0037 2.99624 21.0037H13.0004C13.5529 21.0037 14.0008 20.5558 14.0008 20.0033V16.0016C14.0008 12.6866 11.3134 9.99915 7.99832 9.99915Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.0008 18.0025H1.99582"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.082 3.01328L16.2418 2.30598C15.9433 2.23219 15.6274 2.29975 15.3853 2.48919C15.1431 2.67863 15.0015 2.96892 15.0013 3.27639V10.7195C15.0015 11.027 15.1431 11.3172 15.3853 11.5067C15.6274 11.6961 15.9433 11.7637 16.2418 11.6899L19.0029 10.9996"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Trowel Brush</div>
    </div>
  );
};

export const BedroomHanger = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 10.0001V7.90744L13.3823 7.13944C14.0722 6.75624 14.5 6.02917 14.5 5.24006C14.4183 3.92777 13.2929 2.92737 11.9801 3.00006C10.807 2.95138 9.76537 3.74433 9.5 4.88799"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7 16.5H17C17.5523 16.5 18 16.9477 18 17.5V21H6V17.5C6 16.9477 6.44772 16.5 7 16.5Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18 18H19.2386C20.0154 18.0039 20.7016 17.4949 20.9234 16.7504C21.1451 16.006 20.8491 15.2044 20.1968 14.7827L13.4783 10.4362C12.5786 9.8546 11.4214 9.8546 10.5216 10.4362L3.80322 14.7827C3.15085 15.2044 2.85489 16.006 3.07662 16.7504C3.29835 17.4949 3.98462 18.0039 4.76142 18H6"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Hanger</div>
    </div>
  );
};

export const BedDouble = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.0823 14H17.9177C18.3219 14.0084 18.6894 13.7669 18.8421 13.3926C19.0527 12.8161 19.0526 12.1837 18.842 11.6073C18.6883 11.2328 18.32 10.9915 17.9153 11H15.0847C14.68 10.9915 14.3117 11.2328 14.158 11.6073C13.9474 12.1838 13.9473 12.8161 14.1579 13.3926C14.3106 13.7669 14.6781 14.0084 15.0823 14V14Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.08228 14H8.91773C9.32188 14.0084 9.68943 13.7669 9.84208 13.3926C10.0527 12.8161 10.0526 12.1837 9.842 11.6073C9.68828 11.2328 9.32004 10.9915 8.91533 11H6.08467C5.67995 10.9915 5.3117 11.2328 5.158 11.6073C4.94736 12.1838 4.94733 12.8161 5.15792 13.3926C5.31057 13.7669 5.67812 14.0084 6.08228 14V14Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2 21V19"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22 21V19"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3 7H21C22.1046 7 23 7.89543 23 9V18C23 18.5523 22.5523 19 22 19H2C1.44772 19 1 18.5523 1 18V9C1 7.89543 1.89543 7 3 7Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1 14H23"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Bed Double</div>
    </div>
  );
};

export const Bed = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 21V18.9146"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22 21V18.9144"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="1"
          y="14"
          width="22"
          height="5"
          rx="1.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 14V8C21 6.89543 20.1046 6 19 6H5C3.89543 6 3 6.89543 3 8V14"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Bed</div>
    </div>
  );
};

export const DresserDrawer = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="2"
          y="3"
          width="20"
          height="17"
          rx="2"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20 20V21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4 20V21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 3V20"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9 12.5V10.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15 12.5V10.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Dresser Drawer</div>
    </div>
  );
};

export const DressingMirror = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="3"
          y="12"
          width="18"
          height="8"
          rx="2"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19 20V21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5 20V21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 12V20"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M18 12H6V4C6 2.89543 6.89543 2 8 2H16C17.1046 2 18 2.89543 18 4V12Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.5 15H6.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.5 15H15.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Dressing Mirror</div>
    </div>
  );
};

export const SafeBox = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.4749 8.52513C15.8418 9.89197 15.8418 12.108 14.4749 13.4749C13.1081 14.8417 10.892 14.8417 9.52516 13.4749C8.15832 12.108 8.15832 9.89197 9.52516 8.52513C10.892 7.15829 13.1081 7.15829 14.4749 8.52513"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3 5.066V16.935C3 18.075 3.925 19 5.066 19H18.935C20.075 19 21 18.075 21 16.934V5.066C21 3.925 20.075 3 18.934 3H5.066C3.925 3 3 3.925 3 5.066Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.35 11.7L12.65 10.3"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5 21V19"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19 21V19"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 6H22"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 15H22"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Safe Box</div>
    </div>
  );
};

export const SofaDouble = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 19V21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20 19V21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20 11V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6V11"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="2"
          y="11"
          width="6"
          height="4"
          rx="2"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="16"
          y="11"
          width="6"
          height="4"
          rx="2"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="2"
          y="15"
          width="20"
          height="4"
          rx="1.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Sofa</div>
    </div>
  );
};

export const WashingMachine = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5 21H18.779C19.884 21 20.779 20.105 20.779 19V5C20.779 3.895 19.884 3 18.779 3H5C3.895 3 3 3.895 3 5V19C3 20.105 3.895 21 5 21Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.78 8H3"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.53599 16.5V16.5C8.03499 15.632 8.28999 14.525 9.11999 13.964L9.12099 13.963C9.78699 13.512 10.664 13.527 11.314 14L12.686 14.999C13.336 15.472 14.213 15.487 14.879 15.036L14.88 15.035C15.71 14.474 15.964 13.367 15.464 12.499V12.499"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.8284 11.6716C16.3905 13.2337 16.3905 15.7663 14.8284 17.3284C13.2663 18.8905 10.7336 18.8905 9.17154 17.3284C7.60944 15.7663 7.60944 13.2337 9.17154 11.6716C10.7336 10.1095 13.2663 10.1095 14.8284 11.6716"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16 5.5H18"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Washing Machine</div>
    </div>
  );
};
